<template>
  <div class="notice-detail">
    <div class="">
      <el-table
        :data="noticeData"
        :header-cell-style="{
          background: '#EDF4F9'
        }"
        style="width: 100%; height: 243px;"
      >
        <el-table-column
          show-overflow-tooltip
          prop="noticeTitle"
          label="公告名称"
          width="425px"
        >
          <template slot-scope="{ row }">
            <a @click="handleView(row)">
              {{ row.noticeTitle }}
            </a>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="bigClassName"
          label="类别"
          width="180">
          <template slot-scope="{ row }"
                ><span>{{ row.bigClassName.join(",") }}</span></template
              >
        </el-table-column>
        <el-table-column
          prop="purchaseTypeName"
          label="采购方式">
        </el-table-column> -->
        <el-table-column prop="noticeStartTime" label="发布时间">
        </el-table-column>
        <!-- <el-table-column
          prop="firstRoundEndTime"
          label="报名截止时间">
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "noticeItem",
  data() {
    return {
      // noticeData: [],
    };
  },
  props: {
    noticeData: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
    //查看
    handleView(row) {
      //评标结果、采购公告
      this.$router.push({
        path: "/announcementDetail",
        query: {
          noticeId: row.noticeId,
          schemeId: row.schemeId,
          source: this.source,
          type: row.type
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.notice-detail {
  width: 580px;
  // height: 327px;
}
/deep/ .el-table__row {
  height: 36px;
  line-height: 36px;
}
</style>
